module.exports = __webpack_public_path__ + "static/images/cover_C2.add5823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cover/cover_C2.png
// module id = CZ0s
// module chunks = 8